export const DeliveryMode = {
  "DIRECT_TO_LOCATION": 0,
  "YAY_FOOD_POLE": 1,
  "PICKUP_AREA": 2,
  "DIRECT_TO_CUSTOMER": 3,
  "LAST_YARD": 4, 
  "LOCKER": 5
}